import { getApiUrl } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const fetchNotificationPreferences = async () => {
  const response = await fetch(getApiUrl('/api/notifications/push/preferences'), {
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to load notification preferences');
  return data;
};

export const updateNotificationPreferences = async (preferences) => {
  const response = await fetch(getApiUrl('/api/notifications/push/preferences'), {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(preferences),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to save notification preferences');
  return data;
};

export const sendTestPushNotification = async () => {
  const response = await fetch(getApiUrl('/api/notifications/push/test'), {
    method: 'POST',
    headers: authHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Failed to send test notification');
  return data;
};

export const unsubscribeAllPushSubscriptions = async () => {
  const token = localStorage.getItem('token');
  if (!token || !('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager?.getSubscription();
    if (!subscription?.endpoint) return;

    await fetch(getApiUrl('/api/notifications/push/subscribe'), {
      method: 'DELETE',
      headers: authHeaders(),
      body: JSON.stringify({ endpoint: subscription.endpoint }),
    });
    await subscription.unsubscribe();
  } catch (error) {
    console.warn('[PUSH] Unsubscribe failed:', error?.message || error);
  }
};
